import service from './axios';

export const fetchExpressCompanies = () => service.get('/manage/express/companies');
export const syncExpressCompaniesFromWechat = () => service.post('/manage/express/companies/sync');
export const getConfiguredExpressAccounts = () => service.get('/manage/express/companies/configured-accounts');
export const updateExpressCompanyStatus = (id) => service.put(`/manage/express/companies/${id}/toggle`);

export const getShippingAddress = () => service.get('/manage/express/shipping-address');
export const saveShippingAddress = (data) => service.put('/manage/express/shipping-address', data);

export const getAvailableLogistics = () => service.get('/manage/express/available-companies');
export const shipOrder = (id, data) => service.post(`/manage/orders/${id}/ship`, data);
export const getLogisticsTracking = (orderId) => service.get(`/manage/orders/${orderId}/logistics/tracking`);
